// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navBar {
  position: fixed;
  top: 0;
  width: 100%;
  height: 10%;
  min-height: 60px;
  z-index: 999;
  box-shadow: 0px 5px 9px 0px rgba(0,0,0,0.7);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}
.links {
  flex-direction: row;
  display: flex;
  right: 0;
  justify-content: space-between;
  height: 100%;
  vertical-align: middle;
  top: 0;
  align-items: center;
  margin-right: 20px;
  flex-wrap: wrap;
}
.link {
  font-size: 1rem;
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.link:hover {
  color: #ba7a27;
}

.logo {
  height: 90%;
  width: auto;
  margin-left: 20px;
  align-self: center;
  cursor: pointer;
}

/* Responsive styles */
@media (max-width: 1100px) {
  .link {
    font-size: 0.9rem;
    margin-right: 8px;
    margin-left: 8px;
  }
}

@media (max-width: 900px) {
  .navBar {
    height: auto;
    min-height: 70px;
    padding: 10px 0;
  }
  
  .links {
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 5px;
  }
  
  .link {
    font-size: 0.85rem;
    margin-right: 6px;
    margin-left: 6px;
  }
}

@media (max-width: 600px) {
  .navBar {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
  
  .logo {
    height: 40px;
    margin-left: 0;
    margin-bottom: 10px;
  }
  
  .links {
    width: 100%;
    justify-content: center;
    margin-right: 0;
    gap: 8px;
  }
  
  .link {
    font-size: 0.8rem;
    margin: 3px 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navBar/navBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".navBar {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: 10%;\n  min-height: 60px;\n  z-index: 999;\n  box-shadow: 0px 5px 9px 0px rgba(0,0,0,0.7);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n}\n.links {\n  flex-direction: row;\n  display: flex;\n  right: 0;\n  justify-content: space-between;\n  height: 100%;\n  vertical-align: middle;\n  top: 0;\n  align-items: center;\n  margin-right: 20px;\n  flex-wrap: wrap;\n}\n.link {\n  font-size: 1rem;\n  margin-right: 10px;\n  margin-left: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.3s ease;\n}\n\n.link:hover {\n  color: #ba7a27;\n}\n\n.logo {\n  height: 90%;\n  width: auto;\n  margin-left: 20px;\n  align-self: center;\n  cursor: pointer;\n}\n\n/* Responsive styles */\n@media (max-width: 1100px) {\n  .link {\n    font-size: 0.9rem;\n    margin-right: 8px;\n    margin-left: 8px;\n  }\n}\n\n@media (max-width: 900px) {\n  .navBar {\n    height: auto;\n    min-height: 70px;\n    padding: 10px 0;\n  }\n  \n  .links {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 5px;\n  }\n  \n  .link {\n    font-size: 0.85rem;\n    margin-right: 6px;\n    margin-left: 6px;\n  }\n}\n\n@media (max-width: 600px) {\n  .navBar {\n    flex-direction: column;\n    height: auto;\n    padding: 10px;\n  }\n  \n  .logo {\n    height: 40px;\n    margin-left: 0;\n    margin-bottom: 10px;\n  }\n  \n  .links {\n    width: 100%;\n    justify-content: center;\n    margin-right: 0;\n    gap: 8px;\n  }\n  \n  .link {\n    font-size: 0.8rem;\n    margin: 3px 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
